// extracted by mini-css-extract-plugin
module.exports = {"HowToCard":"HowToCard_HowToCard__vf8CR","HeaderSpan":"HowToCard_HeaderSpan__3R9H7"};